// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"navigationFooter_footerContainer__mDvaM","footerGrid":"navigationFooter_footerGrid__qkenH"};